module.exports = __webpack_public_path__ + "img/Logo.01087011.svg";